import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        width: '100%',
        maxWidth: 480,
        display: 'flex',
        flexDirection: 'column',
        background: '#ffecec',
        border: '1px solid #f4d6d6',
    },
    error: {
        margin: '0px auto 0',
        color: '#c03618',
    }
}))

export default useStyles;
